import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials} = useGLTF("/plots/02-Garden.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }

  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube670.geometry}
        material={materials["00-Base2"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube685.geometry}
        material={materials["02-BenchWood"]}
        position={[0, 0.189, 0.605]}
        rotation={[1.681, -Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube689.geometry}
        material={materials["00-Grass1"]}
        position={[-0.624, 0.106, 0.625]}
        scale={[1.011, 0.771, 0.997]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube701.geometry}
        material={materials["02-BenchMetal"]}
        position={[-0.618, 0.124, -0.137]}
        rotation={[Math.PI, 0, Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube709.geometry}
        material={materials["01-TreeTrunk"]}
        position={[0.458, 0.129, 0.741]}
        rotation={[0, -1.201, 0]}
        scale={0.854}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder112.geometry}
        material={materials["03-FountainWhite"]}
        position={[0.001, 0.141, -0.005]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <group position={[0.001, 0.103, -0.005]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder093.geometry}
          material={materials["03-FountainWhite"]}
        ><Outlines thickness={outlineThickness}/></mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder093_1.geometry}
          material={materials["03-FountainWhite2"]}
        ><Outlines thickness={outlineThickness}/></mesh>
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder138.geometry}
        material={materials["01-TreeGreen2"]}
        position={[-0.747, 0.249, -0.477]}
        rotation={[-Math.PI, 1.449, -Math.PI]}
        scale={0.855}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder154.geometry}
        material={materials["01-TreeGreen1"]}
        position={[0.458, 0.356, 0.741]}
        rotation={[0, -0.787, 0]}
        scale={0.854}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder157.geometry}
        material={materials["03-FountainWater"]}
        position={[0.001, 0.347, -0.005]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/02-Garden.glb");
